import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
// Phase 1 (Executive Redesign Foundation) — load the design-system
// `--ds-*` CSS variables globally so primitives under `@/design-system`
// resolve correctly regardless of which page mounts them first. This
// import is purely additive: no existing page consumes these variables
// yet, so it never overrides legacy styling.
import "@/design-system/tokens.css";
import App from "@/App";

// Capture ?ref=CODE synchronously at app bootstrap, before any React/Router
// rendering can occur. The value is stashed in sessionStorage and read back by
// the Signup page. This guarantees the referral code survives any auth-state
// resolution that might cause a re-render or a redirect that strips the URL
// search params (e.g. a stale-cookie auth flicker).
try {
  const url = new URL(window.location.href);
  const ref = (url.searchParams.get("ref") || "").trim().toUpperCase();
  if (ref) {
    window.sessionStorage.setItem("iaos_pending_ref", ref);
  }
} catch (e) {
  /* sessionStorage or URL parsing not available; safe to ignore. */
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
